import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

import { formatPhoneNumber, getFormattedPriceByBrand, getDateInSuperScriptForm } from "@dp/common";
import { computed, makeObservable, observable, runInAction } from "mobx";
import moment from "moment-timezone";
import i18next from "i18next";
import BrandRules from "../../utils/BrandRules";
export var ORDER_STATUS = {
  CHECK_OPEN: "CHECK_OPEN",
  OPEN: "OPEN",
  FIREDTOKITCHEN: "FIREDTOKITCHEN",
  PREPARED: "PREPARED",
  CHECK_CLOSED: "CHECK_CLOSED",
  CLOSED: "CLOSED",
  CHECK_CANCELLED: "CHECK_CANCELLED",
  CANCEL: "CANCEL"
};
var OrderStatusModel = (_class = /*#__PURE__*/function () {
  function OrderStatusModel(platformUtil) {
    _classCallCheck(this, OrderStatusModel);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor2, this);

    _initializerDefineProperty(this, "_disableCurbsideCheckInButton", _descriptor3, this);

    _initializerDefineProperty(this, "_checkSummary", _descriptor4, this);

    _initializerDefineProperty(this, "_restaurant", _descriptor5, this);

    _initializerDefineProperty(this, "_isCheckSummaryLoading", _descriptor6, this);

    makeObservable(this);
  }

  _createClass(OrderStatusModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setCheckSummaryData",
    value: function setCheckSummaryData(checkSummary) {
      var _this3 = this;

      runInAction(function () {
        _this3._checkSummary = checkSummary;
      });
    }
  }, {
    key: "setRestaurantData",
    value: function setRestaurantData(restaurant) {
      var _this4 = this;

      runInAction(function () {
        _this4._restaurant = restaurant;
      });
    }
  }, {
    key: "_indexofCurrentOrderStatus",
    value: function _indexofCurrentOrderStatus() {
      var orderStatusCompleteStates = [this.isOrderCheckOpen, this.isOrderFiredToKitched, this.isOrderPrepared, this.isOrderCheckClosed];
      return orderStatusCompleteStates === null || orderStatusCompleteStates === void 0 ? void 0 : orderStatusCompleteStates.findIndex(function (state) {
        return state === true;
      });
    }
    /**
     *
     * @param _orderStatus: current order status
     * @param _alternateOrderStatus: this is added to support curbside upwards compatible i.e CHECK_OPEN and OPEN
     *
     */

  }, {
    key: "_getOrderStatusTime",
    value: function _getOrderStatusTime(_orderStatus, _alternateOrderStatus) {
      var _this$_checkSummary$o, _this$_checkSummary, _this$_checkSummary$o2, _this$_checkSummary$o3, _statuses$statusindex;

      var statuses = (_this$_checkSummary$o = (_this$_checkSummary = this._checkSummary) === null || _this$_checkSummary === void 0 ? void 0 : (_this$_checkSummary$o2 = _this$_checkSummary.orderHistory) === null || _this$_checkSummary$o2 === void 0 ? void 0 : (_this$_checkSummary$o3 = _this$_checkSummary$o2.statusHistory) === null || _this$_checkSummary$o3 === void 0 ? void 0 : _this$_checkSummary$o3.statuses) !== null && _this$_checkSummary$o !== void 0 ? _this$_checkSummary$o : [];
      var statusindex = statuses === null || statuses === void 0 ? void 0 : statuses.findIndex(function (status) {
        return (status === null || status === void 0 ? void 0 : status.status) === _orderStatus || (status === null || status === void 0 ? void 0 : status.status) === _alternateOrderStatus;
      });

      if (statusindex === -1) {
        return "";
      }

      return moment((_statuses$statusindex = statuses[statusindex]) === null || _statuses$statusindex === void 0 ? void 0 : _statuses$statusindex.dateTime).parseZone().format("h:mm A");
    }
  }, {
    key: "_getOrderPreparedStatusHighlightedData",
    value: function _getOrderPreparedStatusHighlightedData() {
      var isOrderPrepared = this.isOrderPrepared;
      var isCheckInAvailable = this.isCheckInAvailable || this.isCheckInAvailableByTimeCondition;
      var isGuestCheckedIn = this.isGuestCheckedIn;
      var verbiageTitle = "";
      var verbiageSubTitle = "";
      var defaultCheckInAvailableAfterMessage = {
        defaultValue: "You\u2019ll be able to check in ".concat(this.checkInAvailableAfter, " minutes before your pickup time."),
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        0: this.checkInAvailableAfter
      };
      var defaultSubTitle = "We’ll bring your order out when it is ready.";

      if (!this.isCurbsideTogo) {
        // if we don't have vehicle-info consider it as Out of kitchen, Checked - in
        return {
          verbiageTitle: i18next.t("label.ot_status.3f", {
            defaultValue: "You’re Checked In"
          }),
          verbiageSubTitle: i18next.t("text.ot_status.3f", {
            defaultValue: defaultSubTitle
          }),
          isHighlighted: isOrderPrepared
        };
      }

      if (isOrderPrepared === false && isCheckInAvailable === false) {
        // Right after order submit, CI NOT available
        verbiageTitle = i18next.t("label.ot_status.3a", {
          defaultValue: "Get Ready to Check In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3a", defaultCheckInAvailableAfterMessage);
      } else if (isOrderPrepared === false && isCheckInAvailable === true && isGuestCheckedIn === false) {
        // Still in kitchen, CI available but not checked-in
        verbiageTitle = i18next.t("label.ot_status.3b", {
          defaultValue: "Check In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3b", {
          defaultValue: defaultSubTitle
        });
      } else if (isCheckInAvailable === true && isGuestCheckedIn === true && this.isPickUpTimePassed) {
        // Past pickup time
        verbiageTitle = i18next.t("label.ot_status.3g", {
          defaultValue: "Expertly Grilled Steak Is Coming"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3g", {
          defaultValue: "We’ll be out shortly with your order."
        });
      } else if (isOrderPrepared === false && isCheckInAvailable === true && isGuestCheckedIn === true) {
        // Still in kitchen, Checked - in
        verbiageTitle = i18next.t("label.ot_status.3c", {
          defaultValue: "You’re Checked In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3c", {
          defaultValue: defaultSubTitle
        });
      } else if (isOrderPrepared === true && isCheckInAvailable === false) {
        // Out of kitchen, CI NOT available
        verbiageTitle = i18next.t("label.ot_status.3d", {
          defaultValue: "Get Ready to Check In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3d", defaultCheckInAvailableAfterMessage);
      } else if (isOrderPrepared === true && isCheckInAvailable === true && isGuestCheckedIn === false) {
        // Out of kitchen, CI available but not checked-in
        verbiageTitle = i18next.t("label.ot_status.3e", {
          defaultValue: "Check In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3e", {
          defaultValue: defaultSubTitle
        });
      } else if (isOrderPrepared === true && isCheckInAvailable === true && isGuestCheckedIn === true) {
        // Out of kitchen, Checked - in
        verbiageTitle = i18next.t("label.ot_status.3f", {
          defaultValue: "You’re Checked In"
        });
        verbiageSubTitle = i18next.t("text.ot_status.3f", {
          defaultValue: defaultSubTitle
        });
      } else {
        i18next.t("label.ot_status.3", {
          defaultValue: "Packing in Progress"
        });
        i18next.t("text.ot_status.3", {
          defaultValue: "We are about to bring out your order."
        });
      }

      return {
        verbiageTitle: verbiageTitle,
        verbiageSubTitle: verbiageSubTitle,
        isHighlighted: (isOrderPrepared || isCheckInAvailable) && !this.isOrderCheckClosed
      };
    }
  }, {
    key: "_getOrderPreparedStatusDynamicVerbiage",
    value: function _getOrderPreparedStatusDynamicVerbiage(indexofCurrentOrderStatus) {
      var title = i18next.t("label.ot_status.3", {
        defaultValue: "Packing in Progress"
      });
      var subTitle = i18next.t("text.ot_status.3", {
        defaultValue: "We are about to bring out your order."
      });
      var isCurrent = this.isOrderPrepared;

      if (this.isDynamicVerbiageEnabled) {
        var _this$_getOrderPrepar = this._getOrderPreparedStatusHighlightedData(),
            verbiageTitle = _this$_getOrderPrepar.verbiageTitle,
            verbiageSubTitle = _this$_getOrderPrepar.verbiageSubTitle,
            isHighlighted = _this$_getOrderPrepar.isHighlighted;

        title = verbiageTitle;
        subTitle = verbiageSubTitle;
        isCurrent = isHighlighted;
      }

      return {
        statusIconName: "order-packing-progress-status",
        title: title,
        subTitle: subTitle,
        isCompleted: indexofCurrentOrderStatus > 2,
        isCurrent: isCurrent,
        isLast: false,
        time: this._getOrderStatusTime(ORDER_STATUS.PREPARED),
        timeMessage: this.timeMessageForPackingInProgress
      };
    }
  }, {
    key: "setIsCheckSummaryLoading",
    value: function setIsCheckSummaryLoading(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._isCheckSummaryLoading = val;
      });
    }
  }, {
    key: "disableCurbsideCheckInButton",
    get: function get() {
      return this._disableCurbsideCheckInButton;
    }
  }, {
    key: "restaurantName",
    get: function get() {
      var _this$_restaurant;

      return (_this$_restaurant = this._restaurant) === null || _this$_restaurant === void 0 ? void 0 : _this$_restaurant.restaurantName;
    }
  }, {
    key: "restaurantPhoneNumber",
    get: function get() {
      var _this$_restaurant2, _this$_restaurant2$co, _this$_restaurant2$co2;

      var phone = (_this$_restaurant2 = this._restaurant) === null || _this$_restaurant2 === void 0 ? void 0 : (_this$_restaurant2$co = _this$_restaurant2.contactDetail) === null || _this$_restaurant2$co === void 0 ? void 0 : (_this$_restaurant2$co2 = _this$_restaurant2$co.phoneDetail) === null || _this$_restaurant2$co2 === void 0 ? void 0 : _this$_restaurant2$co2.find(function (p) {
        return p.type === "Primary";
      });
      return formatPhoneNumber(phone === null || phone === void 0 ? void 0 : phone.phoneNumber);
    }
  }, {
    key: "pickUpTime",
    get: function get() {
      var _this$_checkSummary2, _this$_checkSummary2$;

      var pickUpTimestamp = (_this$_checkSummary2 = this._checkSummary) === null || _this$_checkSummary2 === void 0 ? void 0 : (_this$_checkSummary2$ = _this$_checkSummary2.orderSummary) === null || _this$_checkSummary2$ === void 0 ? void 0 : _this$_checkSummary2$.pickUpTimestamp;
      var pickUpDateTime = moment(pickUpTimestamp);
      var today = moment();

      if (pickUpDateTime && pickUpTimestamp) {
        if (pickUpDateTime.isSame(today, "day")) {
          return "Today, ".concat(pickUpDateTime.utc().utcOffset(pickUpTimestamp).format("h:mm A"));
        }

        return getDateInSuperScriptForm(pickUpDateTime.utc().utcOffset(pickUpTimestamp).format("MMM Do, h:mm A"));
      } else return "-:-";
    }
  }, {
    key: "isOrderCheckOpen",
    get: function get() {
      var _this$_checkSummary3, _this$_checkSummary3$;

      var orderStatus = (_this$_checkSummary3 = this._checkSummary) === null || _this$_checkSummary3 === void 0 ? void 0 : (_this$_checkSummary3$ = _this$_checkSummary3.orderSummary) === null || _this$_checkSummary3$ === void 0 ? void 0 : _this$_checkSummary3$.orderStatus;
      return orderStatus === ORDER_STATUS.CHECK_OPEN || orderStatus === ORDER_STATUS.OPEN;
    }
  }, {
    key: "isOrderFiredToKitched",
    get: function get() {
      var _this$_checkSummary4, _this$_checkSummary4$;

      return ((_this$_checkSummary4 = this._checkSummary) === null || _this$_checkSummary4 === void 0 ? void 0 : (_this$_checkSummary4$ = _this$_checkSummary4.orderSummary) === null || _this$_checkSummary4$ === void 0 ? void 0 : _this$_checkSummary4$.orderStatus) === ORDER_STATUS.FIREDTOKITCHEN;
    }
  }, {
    key: "isOrderPrepared",
    get: function get() {
      var _this$_checkSummary5, _this$_checkSummary5$;

      return ((_this$_checkSummary5 = this._checkSummary) === null || _this$_checkSummary5 === void 0 ? void 0 : (_this$_checkSummary5$ = _this$_checkSummary5.orderSummary) === null || _this$_checkSummary5$ === void 0 ? void 0 : _this$_checkSummary5$.orderStatus) === ORDER_STATUS.PREPARED;
    }
  }, {
    key: "isOrderCheckClosed",
    get: function get() {
      var _this$_checkSummary6, _this$_checkSummary6$;

      var orderStatus = (_this$_checkSummary6 = this._checkSummary) === null || _this$_checkSummary6 === void 0 ? void 0 : (_this$_checkSummary6$ = _this$_checkSummary6.orderSummary) === null || _this$_checkSummary6$ === void 0 ? void 0 : _this$_checkSummary6$.orderStatus;
      return orderStatus === ORDER_STATUS.CHECK_CLOSED || orderStatus === ORDER_STATUS.CLOSED;
    }
  }, {
    key: "isPickUpTimePassed",
    get: function get() {
      var _this$_checkSummary7, _this$_checkSummary7$, _this$_checkSummary8, _this$_checkSummary8$, _this$_checkSummary9, _this$_checkSummary9$, _this$_checkSummary9$2, _this$_checkSummary9$3;

      var pickUpDateTime = (_this$_checkSummary7 = this._checkSummary) === null || _this$_checkSummary7 === void 0 ? void 0 : (_this$_checkSummary7$ = _this$_checkSummary7.orderSummary) === null || _this$_checkSummary7$ === void 0 ? void 0 : _this$_checkSummary7$.pickUpDateTime;
      var currentDateTime = (_this$_checkSummary8 = this._checkSummary) === null || _this$_checkSummary8 === void 0 ? void 0 : (_this$_checkSummary8$ = _this$_checkSummary8.header) === null || _this$_checkSummary8$ === void 0 ? void 0 : _this$_checkSummary8$.timeStamp; // get timeZone offSet

      var timezoneOffset = moment.parseZone((_this$_checkSummary9 = this._checkSummary) === null || _this$_checkSummary9 === void 0 ? void 0 : (_this$_checkSummary9$ = _this$_checkSummary9.orderHistory) === null || _this$_checkSummary9$ === void 0 ? void 0 : (_this$_checkSummary9$2 = _this$_checkSummary9$.statusHistory) === null || _this$_checkSummary9$2 === void 0 ? void 0 : (_this$_checkSummary9$3 = _this$_checkSummary9$2.statuses[0]) === null || _this$_checkSummary9$3 === void 0 ? void 0 : _this$_checkSummary9$3.dateTime).format("Z"); // convert utc timestamp to localtime

      var timeStampInLocalTime = moment(currentDateTime).utcOffset(timezoneOffset);
      return timeStampInLocalTime.isSameOrAfter(moment(pickUpDateTime).utcOffset(timezoneOffset, true));
    }
  }, {
    key: "timeMessageForPackingInProgress",
    get: function get() {
      var _this$_checkSummary10, _this$_checkSummary11;

      var pickUpDateTime = (_this$_checkSummary10 = this._checkSummary) === null || _this$_checkSummary10 === void 0 ? void 0 : (_this$_checkSummary11 = _this$_checkSummary10.orderSummary) === null || _this$_checkSummary11 === void 0 ? void 0 : _this$_checkSummary11.pickUpDateTime;
      var time = moment(pickUpDateTime).format("h:mm A");

      if (this.isPickUpTimePassed) {
        return i18next.t("text.ot_status.3h2", {
          defaultValue: "See you shortly."
        });
      }

      return i18next.t("text.ot_status.3h1", {
        defaultValue: "See you at ".concat(time, "."),
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        0: time
      });
    }
  }, {
    key: "isDynamicVerbiageEnabled",
    get: function get() {
      return !(i18next.exists("label.ot_status.3") && i18next.exists("text.ot_status.3"));
    }
  }, {
    key: "orderTrackingStatusStates",
    get: function get() {
      var indexofCurrentOrderStatus = this._indexofCurrentOrderStatus();

      var orderPreparedStatusDynamicVerbiageData = this._getOrderPreparedStatusDynamicVerbiage(indexofCurrentOrderStatus);

      return [{
        statusIconName: "order-received-check",
        title: i18next.t("label.ot_status.1", {
          defaultValue: "Order Received"
        }),
        subTitle: i18next.t("text.ot_status.1", {
          defaultValue: "Your order has been received."
        }),
        isCompleted: orderPreparedStatusDynamicVerbiageData.isCurrent || indexofCurrentOrderStatus > 0,
        isCurrent: this.isOrderCheckOpen && !orderPreparedStatusDynamicVerbiageData.isCurrent,
        isLast: false,
        time: this._getOrderStatusTime(ORDER_STATUS.CHECK_OPEN, ORDER_STATUS.OPEN)
      }, {
        statusIconName: "order-preparing-satus",
        title: i18next.t("label.ot_status.2", {
          defaultValue: "Preparation"
        }),
        subTitle: i18next.t("text.ot_status.2", {
          defaultValue: "Your food is being prepared."
        }),
        isCompleted: orderPreparedStatusDynamicVerbiageData.isCurrent || indexofCurrentOrderStatus > 1,
        isCurrent: this.isOrderFiredToKitched && !orderPreparedStatusDynamicVerbiageData.isCurrent,
        isLast: false,
        time: this._getOrderStatusTime(ORDER_STATUS.FIREDTOKITCHEN)
      }, orderPreparedStatusDynamicVerbiageData, {
        statusIconName: "order-picked-up-status",
        title: i18next.t("label.ot_status.4", {
          defaultValue: "Order picked up"
        }),
        subTitle: i18next.t("text.ot_status.4", {
          defaultValue: "Your order has been picked up."
        }),
        isCompleted: indexofCurrentOrderStatus >= 3,
        isCurrent: this.isOrderCheckClosed,
        isLast: true,
        time: this._getOrderStatusTime(ORDER_STATUS.CHECK_CLOSED, ORDER_STATUS.CLOSED)
      }];
    }
  }, {
    key: "isPayNowButtonEnabled",
    get: function get() {
      var _this$_restaurant3, _this$_restaurant3$fe;

      var payNowEnable = (_this$_restaurant3 = this._restaurant) === null || _this$_restaurant3 === void 0 ? void 0 : (_this$_restaurant3$fe = _this$_restaurant3.features) === null || _this$_restaurant3$fe === void 0 ? void 0 : _this$_restaurant3$fe.payNowEnable;
      return payNowEnable && this.checkHasNoPayment;
    } // check if any payment information available

  }, {
    key: "checkHasNoPayment",
    get: function get() {
      var _this$_checkSummary12, _this$_checkSummary13; // removed savePaymentAvailable from here


      return (_this$_checkSummary12 = this._checkSummary) === null || _this$_checkSummary12 === void 0 ? void 0 : (_this$_checkSummary13 = _this$_checkSummary12.orderSummary) === null || _this$_checkSummary13 === void 0 ? void 0 : _this$_checkSummary13.isPaymentRequired;
    }
  }, {
    key: "isCurbsideTogo",
    get: function get() {
      var _this$_restaurant4, _this$_restaurant4$fe, _this$_checkSummary14, _this$_checkSummary15, _this$_checkSummary16, _this$_checkSummary17;

      var CURBSIDE = "CURBSIDE";
      var WALKIN = "WALKIN";
      var curbsideTogo = (_this$_restaurant4 = this._restaurant) === null || _this$_restaurant4 === void 0 ? void 0 : (_this$_restaurant4$fe = _this$_restaurant4.features) === null || _this$_restaurant4$fe === void 0 ? void 0 : _this$_restaurant4$fe.curbSideTogoEnabled;
      var vehicleInformationAvailable = (_this$_checkSummary14 = this._checkSummary) !== null && _this$_checkSummary14 !== void 0 && (_this$_checkSummary15 = _this$_checkSummary14.orderSummary) !== null && _this$_checkSummary15 !== void 0 && _this$_checkSummary15.vehicleInformation ? true : false;
      var fulfillmentMethodCompatibilityInit = vehicleInformationAvailable ? CURBSIDE : WALKIN;
      var fulfillmentMethod = ((_this$_checkSummary16 = this._checkSummary) === null || _this$_checkSummary16 === void 0 ? void 0 : _this$_checkSummary16.orderSummary.fulfillmentMethod) === undefined ? fulfillmentMethodCompatibilityInit : (_this$_checkSummary17 = this._checkSummary) === null || _this$_checkSummary17 === void 0 ? void 0 : _this$_checkSummary17.orderSummary.fulfillmentMethod;
      var isCurbsideFulfillmentMethod = fulfillmentMethod === CURBSIDE;
      return curbsideTogo && isCurbsideFulfillmentMethod;
    }
  }, {
    key: "vehicleInformation",
    get: function get() {
      var _this$_checkSummary18, _this$_checkSummary19;

      return (_this$_checkSummary18 = this._checkSummary) === null || _this$_checkSummary18 === void 0 ? void 0 : (_this$_checkSummary19 = _this$_checkSummary18.orderSummary) === null || _this$_checkSummary19 === void 0 ? void 0 : _this$_checkSummary19.vehicleInformation;
    }
  }, {
    key: "amount",
    get: function get() {
      var _BrandRules, _this$_appAttributes, _this$_checkSummary20, _this$_checkSummary21, _this$_checkSummary22, _this$_checkSummary23;

      var format = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat();
      var price = Number((_this$_checkSummary20 = this._checkSummary) === null || _this$_checkSummary20 === void 0 ? void 0 : (_this$_checkSummary21 = _this$_checkSummary20.orderSummary) === null || _this$_checkSummary21 === void 0 ? void 0 : _this$_checkSummary21.tipAmount) + Number((_this$_checkSummary22 = this._checkSummary) === null || _this$_checkSummary22 === void 0 ? void 0 : (_this$_checkSummary23 = _this$_checkSummary22.orderSummary) === null || _this$_checkSummary23 === void 0 ? void 0 : _this$_checkSummary23.totalAmount);
      return getFormattedPriceByBrand(price, format);
    }
  }, {
    key: "orderId",
    get: function get() {
      var _this$_checkSummary24, _this$_checkSummary25, _this$_checkSummary26, _this$_checkSummary27, _this$_checkSummary28, _this$_checkSummary29;

      var orderId = (_this$_checkSummary24 = this._checkSummary) === null || _this$_checkSummary24 === void 0 ? void 0 : (_this$_checkSummary25 = _this$_checkSummary24.orderSummary) === null || _this$_checkSummary25 === void 0 ? void 0 : (_this$_checkSummary26 = _this$_checkSummary25.orderIDs) === null || _this$_checkSummary26 === void 0 ? void 0 : (_this$_checkSummary27 = _this$_checkSummary26.orderID.find(function (ids) {
        return (ids === null || ids === void 0 ? void 0 : ids.source) === "DP";
      })) === null || _this$_checkSummary27 === void 0 ? void 0 : _this$_checkSummary27.ID;
      var checkNumber = (_this$_checkSummary28 = this._checkSummary) === null || _this$_checkSummary28 === void 0 ? void 0 : (_this$_checkSummary29 = _this$_checkSummary28.orderSummary) === null || _this$_checkSummary29 === void 0 ? void 0 : _this$_checkSummary29.checkNumber;
      return orderId ? "Order #".concat(orderId) : "Check # ".concat(checkNumber);
    }
  }, {
    key: "isCheckInAvailable",
    get: function get() {
      var _this$_checkSummary30, _this$_checkSummary31;

      return (_this$_checkSummary30 = this._checkSummary) === null || _this$_checkSummary30 === void 0 ? void 0 : (_this$_checkSummary31 = _this$_checkSummary30.orderSummary) === null || _this$_checkSummary31 === void 0 ? void 0 : _this$_checkSummary31.checkInAvailable;
    }
  }, {
    key: "isGuestCheckedIn",
    get: function get() {
      var _this$_checkSummary32, _this$_checkSummary33;

      return !!((_this$_checkSummary32 = this._checkSummary) !== null && _this$_checkSummary32 !== void 0 && (_this$_checkSummary33 = _this$_checkSummary32.orderSummary) !== null && _this$_checkSummary33 !== void 0 && _this$_checkSummary33.guestCheckedIn);
    }
  }, {
    key: "isCheckInAvailableByTimeCondition",
    get: function get() {
      var _this$_checkSummary34, _this$_checkSummary35, _this$_checkSummary36, _this$_checkSummary37;

      var checkInAvailableAfter = (_this$_checkSummary34 = this._checkSummary) === null || _this$_checkSummary34 === void 0 ? void 0 : (_this$_checkSummary35 = _this$_checkSummary34.orderSummary) === null || _this$_checkSummary35 === void 0 ? void 0 : _this$_checkSummary35.checkInAvailableAfter;
      var timeStamp = (_this$_checkSummary36 = this._checkSummary) === null || _this$_checkSummary36 === void 0 ? void 0 : (_this$_checkSummary37 = _this$_checkSummary36.header) === null || _this$_checkSummary37 === void 0 ? void 0 : _this$_checkSummary37.timeStamp; // Compare moment time objects, if check-in time has passed
      //  timestamp and checkInAvailableAfter are UTC=ZULU

      var mtimeStamp = moment(timeStamp);
      var mCheckInAvailableAfter = moment(checkInAvailableAfter);
      return mtimeStamp.isSameOrAfter(mCheckInAvailableAfter);
    }
  }, {
    key: "checkInAvailableAfter",
    get: function get() {
      var _this$_checkSummary38, _this$_checkSummary39, _this$_checkSummary40; // this is ISO time from DASH and has timezone


      var checkInAvailableAfter = moment.parseZone((_this$_checkSummary38 = this._checkSummary) === null || _this$_checkSummary38 === void 0 ? void 0 : (_this$_checkSummary39 = _this$_checkSummary38.orderSummary) === null || _this$_checkSummary39 === void 0 ? void 0 : _this$_checkSummary39.checkInAvailableAfter).format("YYYY-MM-DDTHH:mm:ss.sss"); // pickUpDateTime from DASH is ZULU time format but its local time.

      var pickUpDateTime = moment((_this$_checkSummary40 = this._checkSummary) === null || _this$_checkSummary40 === void 0 ? void 0 : _this$_checkSummary40.orderSummary.pickUpDateTime); //getting diff in min

      return pickUpDateTime.diff(checkInAvailableAfter, "minutes");
    }
  }, {
    key: "parkingSpot",
    get: function get() {
      var _this$_checkSummary41, _this$_checkSummary42;

      return (_this$_checkSummary41 = this._checkSummary) === null || _this$_checkSummary41 === void 0 ? void 0 : (_this$_checkSummary42 = _this$_checkSummary41.orderSummary) === null || _this$_checkSummary42 === void 0 ? void 0 : _this$_checkSummary42.ParkingSpot;
    }
  }, {
    key: "isCheckSummaryLoading",
    get: function get() {
      return this._isCheckSummaryLoading;
    }
  }, {
    key: "isCheckedIn",
    get: function get() {
      var _this$_checkSummary43, _this$_checkSummary44;

      return !!((_this$_checkSummary43 = this._checkSummary) !== null && _this$_checkSummary43 !== void 0 && (_this$_checkSummary44 = _this$_checkSummary43.orderSummary) !== null && _this$_checkSummary44 !== void 0 && _this$_checkSummary44.checkInDateTime);
    }
  }, {
    key: "tokenID",
    get: function get() {
      var _this$_checkSummary45, _this$_checkSummary46;

      return (_this$_checkSummary45 = this._checkSummary) === null || _this$_checkSummary45 === void 0 ? void 0 : (_this$_checkSummary46 = _this$_checkSummary45.orderSummary) === null || _this$_checkSummary46 === void 0 ? void 0 : _this$_checkSummary46.tokenID;
    }
  }, {
    key: "orderTracingCounterThreshold",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return Number((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.orderTracingCounterThreshold) || 30;
    }
  }, {
    key: "orderTrackingTimeCounter",
    get: function get() {
      var _this$_appAttributes4, _this$_appAttributes5, _this$_appAttributes6, _this$_appAttributes7;

      if ((_this$_appAttributes4 = this._appAttributes) !== null && _this$_appAttributes4 !== void 0 && (_this$_appAttributes5 = _this$_appAttributes4.configs) !== null && _this$_appAttributes5 !== void 0 && _this$_appAttributes5.orderTrackingTimeCounter && ((_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.orderTrackingTimeCounter) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "checkSummaryLastUpdated",
    get: function get() {
      var _this$_checkSummary47, _this$_checkSummary48;

      return moment((_this$_checkSummary47 = this._checkSummary) === null || _this$_checkSummary47 === void 0 ? void 0 : (_this$_checkSummary48 = _this$_checkSummary47.header) === null || _this$_checkSummary48 === void 0 ? void 0 : _this$_checkSummary48.timeStamp).format("LT");
    }
  }]);

  return OrderStatusModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_disableCurbsideCheckInButton", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_checkSummary", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_restaurant", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isCheckSummaryLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "disableCurbsideCheckInButton", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableCurbsideCheckInButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickUpTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickUpTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderCheckOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderCheckOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderFiredToKitched", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderFiredToKitched"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderPrepared", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderPrepared"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderCheckClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderCheckClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPickUpTimePassed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPickUpTimePassed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeMessageForPackingInProgress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeMessageForPackingInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDynamicVerbiageEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDynamicVerbiageEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTrackingStatusStates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTrackingStatusStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPayNowButtonEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPayNowButtonEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkHasNoPayment", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkHasNoPayment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbsideTogo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbsideTogo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleInformation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleInformation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "amount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "amount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckInAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckInAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGuestCheckedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGuestCheckedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckInAvailableByTimeCondition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckInAvailableByTimeCondition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkInAvailableAfter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInAvailableAfter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parkingSpot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parkingSpot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckSummaryLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckSummaryLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tokenID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tokenID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTracingCounterThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTracingCounterThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTrackingTimeCounter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTrackingTimeCounter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkSummaryLastUpdated", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkSummaryLastUpdated"), _class.prototype)), _class);
export { OrderStatusModel as default };